<template>
  <div class="boards-panel">
    <v-toolbar
    class="boards-panel__toolbar"
    dense
    flat>

      <v-tooltip bottom>
        <v-btn
          @click="$emit('addEmptyBoard')"
          slot="activator"
          icon
          large
          flat>
          <v-icon>add</v-icon>
        </v-btn>
        <span>新增空白白板</span>
      </v-tooltip>

      <v-tooltip bottom>
        <v-btn
          @click="$emit('addImageBoard')"
          slot="activator"
          icon
          large
          flat>
          <v-icon>add_photo_alternate</v-icon>
        </v-btn>
        <span>新增圖片白板</span>
      </v-tooltip>

      <v-spacer />

      <v-tooltip bottom>
        <v-btn
          slot="activator"
          @click="toggle"
          icon
          large
          flat>
          <v-icon>clear</v-icon>
        </v-btn>
        <span>隱藏</span>
      </v-tooltip>
    </v-toolbar>

    <ul class="board-list">
      <li
        class="board-list__item"
        :class="{'list-item--selected': board.id === selectedBoard}"
        :key="board.id"
        v-for="(board) in boards">

        <app-file-item
          @remove="remove(board)"
          @click="switchBoard(board.id)"
          width="200px"
          height="150px"
          :name="board.name"
          :thumbnailObjUrl="board.thumbnailUrl"
          :autoRevokeObjectUrl="true">
          <div v-if="!board.thumbnailUrl" slot="icon" class="title">[空白]</div>
        </app-file-item>
      </li>
    </ul>
  </div>
</template>

<script>
import {mapState} from 'vuex';
import {mapActions} from 'vuex';

export default {
  data() {
    return {
      visible: false,
      selectedBoard: null
    };
  },

  computed: {
    ...mapState('whiteboard', {
      boards: state => state.boards
    })
  },

  mounted() {
    this._toggle = this.toggle.bind(this);
    this.$eventBus.$on('whiteboard-toggle-boards-panel', this._toggle);
  },

  beforeDestroy() {
    this.$eventBus.$off('whiteboard-toggle-boards-panel', this._toggle);
  },

  methods: {
    ...mapActions('whiteboard', {
      removeBoard: 'removeBoard'
    }),

    open() {
      this.visible = true;
      let panel = this.$el;
      Velocity(panel, 'stop');
      Velocity(panel, {translateX: '-100%'}, {duration: 200, easing: 'easeInOutCubic'});
    },

    close() {
      this.visible = false;
      let panel = this.$el;
      Velocity(panel, 'stop');
      Velocity(panel, {translateX: '0%'}, {duration: 200, easing: 'easeInOutCubic', complete: () => {
        // this.$el.style.display = 'none';
      }});
    },

    toggle() {
      if (this.visible) {
        this.close();
      } else {
        this.open();
      }
    },

    async remove(board) {
      this.removeBoard(board.id);
      await this.$nextTick();
      if (this.boards.length) {
        let lastBoardId = this.boards[this.boards.length-1].id;
        this.switchBoard(lastBoardId);
      }
    },

    switchBoard(boardId) {
      this.selectedBoard = boardId;
      this.$eventBus.$emit('whiteboard-switch-board', boardId);
    }
  }
};
</script>

<style lang="stylus" scoped>

.boards-panel {
  padding-top: 48px;
  width: 250px;
  height: 100%;
  position: absolute;
  top: 0;
  right: -250px;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-left: 1px solid $def-border-color;
}

.boards-panel__toolbar {
  border-bottom: 1px solid $def-border-color !important;
}

.board-list {
  width: 100%;
  flex-grow: 1;
  overflow-y: auto;
  padding: 0;
  list-style-type: none;
}

.board-list__item {
  padding: 1rem 0 1rem 0;
  cursor: pointer;
  display: flex;
  justify-content: center;
}
</style>
